import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { FormGroup, Label, Button, Row, Col } from 'reactstrap'
import SelectorBrandDelegation from 'components/SelectorBrandDelegation'
import { updateChannels, updateOverwriteName } from 'redux/actions/marketing'
import SetExcelColumns from './SetExcelColumns'
import OverwriteNameSwitch from './OverwriteNameSwitch'

import './styles.scss'
import { Radio, Select, ButtonTag } from 'components/Form'
// import { company } from 'api'
import { STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW } from '../../../../../constants'
import DKVConfiguration from 'constants/dkv.constants'
import conversations from 'api/conversation/conversations'
import { channelName } from 'constants/channels'
import { getStaticImage } from 'utils/statics'
import { useHistory } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { lang } from 'utils/helpers'

// const _ = require('lodash')

// const { channels: channelsApi } = company

const channels = ['WhatsApp', 'SMS', 'ChatMail', /* 'Telegram', 'Facebook', */ 'Android', 'iOS']
const colNames = [
  'name', 'lastName', 'phone',
  ...DKVConfiguration.isDKV ? ['codcliente'] : [],
  'occasion_id', 'occasion_name'
]

/**
 * Get channelList and schemas
 * @param {string} companyId
 * @param {function} setData
 */
// const getChannels = async (companyId, setChannels) => {
//   try {
//     const { data } = await channelsApi.getChannels(companyId, { channelList: true })
//     setChannels({ channelList: data.channels || [] })
//   } catch (error) {
//     console.error(error)
//   }
// }

const AssignExcelUsers = ({ excelUsers, showPreview }) => {
  const dispatch = useDispatch()

  const { canOverwriteName } = useSelector(store => store.marketing?.campaign || {})

  const [initialUsers /*, setInitialUsers*/] = useState(excelUsers.excelSheets[0].data)
  const [users, setUsers] = useState([])

  const [showSelectColumns, setShowSelectColumns] = useState(false)
  const [cols, setCols] = useState([])

  const [channelChecked, setChannelChecked] = useState('')
  const [channel, setChannel] = useState({ label: I18n.t('dashboard_select-channel'), value: 0 })
  // const [channelsList, setChannelsList] = useState({ channelList: [] })
  const [channelsOptions, setChannelsOptions] = useState([])
  const history = useHistory()
  const { headers } = excelUsers.excelSheets[0]

  // useEffect(() => {
  //   getChannels(company._id, setChannelsList)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [company._id])

  useEffect(() => {
    setChannel({ label: I18n.t('dashboard_select-channel'), value: 0 })
    setChannelsOptions([])
    if (channelChecked)
      loadDataForSMS(channelChecked)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelChecked])

  const handleBrandDelegationSelector = (brand = null, delegation = null) => {
    const updatedUsers = users.map((user) => {
      user.brand = brand
      user.delegation = delegation
      return user
    })
    setUsers(updatedUsers)

  }

  const createCols = () => {
    const defaultOptions = headers.map((header) => ({
      label: header,
      value: header,
    }))

    const columns = colNames.map((elem, idx) => ({
      options: defaultOptions,
      name: elem,
      index: idx,
      key: elem+idx,
      selectedValue: ''
    }))

    setCols(columns)
    return
  }

  const handleChannelSelector = ({ target: { name } }) => {
    setChannelChecked(name.toLowerCase())
    // create cols
    createCols()
    setShowSelectColumns(true)

    // only for sms channel
    setChannel('')
    dispatch(updateChannels([]))

    const updatedUsers = initialUsers.map((user) => {
      user.channel = name
      return user
    })
    setUsers(updatedUsers)
  }

  // handle selected column value
  const handleSelected = ({ label, value }, { name }, colIndex, options) => {
    cols[colIndex].selectedValue = value

    // set next col options
    const nextColOptions = options//.filter((el) => el.label !== label && el.value !== value)
    const nextColIndex = colIndex + 1

    const updatedCols = cols.map((col, index) => {
      if (index === nextColIndex) {
        col.options = nextColOptions //options
      }
      return col
    })

    setCols(updatedCols)

    let updatedUsers = []
    cols.forEach((col) => {
      updatedUsers = initialUsers.map((user) => {
        Object.keys(user).forEach((key) => {
          if (key === col.selectedValue) {
            user[col.name] = user[col.selectedValue]
          }
        })
        return user
      })
    })

    setUsers(updatedUsers)
  }

  const onChangeChannel = (data, value) => {
    setChannel(value)
    dispatch(updateChannels([value._toDB]))
  }

  const loadDataForSMS = (channel) => {
    (async () => {
      try {
        const result = await conversations.getChannelsOPTOUT({ type: channel })
        const numbers = []
        result.data.forEach(it => {
          numbers.push({ label: it.value, value: it.id, assignToMe: it.assignToMe, data: it })
        })

        const _channels = []
        numbers.forEach(it => {
          const _channelName = channelChecked !== 'whatsapp'
            ? channelChecked
            : it.data.provider && it.data.provider === 'whatsapp'
              ? 'whatsapp_whatsapp'
              : 'whatsapp'
          let label = it.label
          if (it?.data?.name) {
            label = `${it.label} (${it.data.name})`
          } else if (it?.data?.delegationName) {
            label = `${it.label} (${it.data.delegationName})`
          }
          _channels.push({
            label,
            value: it.value,
            _toDB: {
              hub: channelName[_channelName].hub,
              value: it.data,
              key: channelChecked,
              id: it.value,
              _id: false,
            },
          })
        })
        setChannelsOptions(_channels)
      } catch (error) {
        console.error(error)
      }
    })()
  }

  const getTooltip = (channel) => {
    if (channel === 'ChatMail') return I18n.t('dashboard_soon')
    else if (['ChatMail', 'WhatsApp', 'SMS'].includes(channel)) return I18n.t('campaigns_tooltip_allow_outbound')
    else return I18n.t('campaigns_tooltip_not_allow_outbound')
  }

  return (
    <div className='assign-users-wrapper'>
      <legend className='rows-found'>{`${excelUsers.rows} filas encontradas`}</legend>
      <br />
      <FormGroup tag='fieldset'>
        <legend className='choose-channel-text'>{I18n.t('excel_table_choose_channel')}</legend>
        <br />
        <FormGroup check inline>
          {channels.map((channel, index) => (
            <Label key={index} check data-tip={getTooltip(channel)}>
              <Radio
                id={`channel${index}`}
                name={channel.toLowerCase()}
                checked={channelChecked === channel.toLowerCase()}
                onChange={handleChannelSelector}
                label={<span className={`radio-label channel-${channel}`}>{channel}</span>}
                disabled={channel === 'ChatMail' ? true : false}
              />
              <ReactTooltip place='bottom' className='react-tooltip-custom-style' />
            </Label>
          ))}
        </FormGroup>
      </FormGroup>
      {showSelectColumns && (
        <>
          {(channelChecked === 'sms' || channelChecked === 'whatsapp') && (
            <>
              <legend className='choose-channel-text'>{I18n.t('dashboard_assign-to')}</legend>
              <Row key={`assign-to-${channelChecked}`}>
                <Col className='mb-3' xs={8}>
                  <SelectorBrandDelegation
                    className='assign-excel-users-selector'
                    onChange={handleBrandDelegationSelector}
                    styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW}
                  />
                </Col>

                <Col className='mb-3' xs={4}>
                  <FormGroup>
                    <Label for='channel'>{I18n.t('dashboard_channel')}</Label>
                    {
                      channelsOptions.length
                        ?
                        <Select
                          defaultValue={channel}
                          value={channel}
                          onChange={onChangeChannel}
                          options={channelsOptions}
                          name='channel'
                          styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW}
                          //disabled={lockedButtons}
                        />
                        :
                        <ButtonTag
                          icon={<img src={getStaticImage('/icons/orange-brand/external-link-primary.svg')} alt='link' />}
                          value={`${lang('dashboard_configure')} ${lang(`channels_${channelChecked}`)}`}
                          onClick={() => history.push(`/dashboard/configurations/channels?c=${channelChecked}`)}
                          className='button-tag-config-channel'
                        />
                    }
                  </FormGroup>
                </Col>
              </Row>

              <legend className='choose-channel-text'>{I18n.t('campaign_excel_user_overwrite_name')}</legend>
              <Row key={`overwrite-${channelChecked}`}>
                <Col className='mb-3' xs={8}>
                  <FormGroup>
                    <OverwriteNameSwitch
                      canOverwriteName={!!canOverwriteName}
                      onOverwriteNameChange={() => {
                        dispatch(updateOverwriteName(!canOverwriteName))
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
          <legend className='choose-channel-text'>{I18n.t('set_excel_columns')}</legend>
          <Row>
            {cols.map((col, index) => {
              return (
                <SetExcelColumns
                  key={index}
                  handleSelected={handleSelected}
                  colName={col.name}
                  colIndex={index}
                  options={col.options}
                  colKey={col.key}
                  exampleValues={initialUsers[0]}
                />
              )
            })}
          </Row>



          <Button color='primary' onClick={() => showPreview(users)}>
            {I18n.t('dashboard_preview')}
          </Button>
        </>
      )}
    </div>
  )
}

export default AssignExcelUsers
